'use client';
import GloLayout from 'lowcode/common/GloLayout';
import ClientComp from './comps';
import styles from './index.module.scss';

export default function Content({ id, data, initIndex = 0, isEditStatus = false }: any) {
    return (
        <GloLayout id={'activity-eco-redeem-rewards'} className={`temp-eco-redeem-rewards ${styles.content}`}>
            <ClientComp data={data} />
        </GloLayout>
    );
}
